import { AnyAction } from 'redux';
import {
  LOGIN_ERROR,
  LOGIN_SET_IS_LOADING,
  LOGIN_SET_LOGIN_MODE,
  LOGIN_SET_MAGIC_LINK_MODEL,
  LOGIN_SET_MODAL_OPEN,
  LOGIN_SET_ORGANIZATIONS,
  LOGIN_SET_REDIRECT_URL,
  LOGIN_SET_USERNAME_PASSWORD,
} from '../constants';
import LoginMode from '../Types/LoginMode';
import LoginOrganization from '../Types/LoginOrganization';
import { MagicLinkModel } from '../Types/MagicLinkModel';

export interface LoginState {
  showChangePassword: boolean;
  isLoading: boolean;
  username: string;
  password: string;
  modalOpen: boolean;
  loginMode: LoginMode;
  organizations?: LoginOrganization[];
  error?: string;
  redirectUrl?: string;
  magicLinkModel?: MagicLinkModel;
}

const DEFAULT_STATE: LoginState = {
  showChangePassword: false,
  isLoading: false,
  username: '',
  password: '',
  modalOpen: false,
  loginMode: LoginMode.Login,
  error: undefined,
  redirectUrl: undefined,
};

export const login = (state = DEFAULT_STATE, action: AnyAction): LoginState => {
  switch (action.type) {
    case LOGIN_SET_IS_LOADING:
    case LOGIN_SET_ORGANIZATIONS:
    case LOGIN_SET_MODAL_OPEN:
    case LOGIN_SET_USERNAME_PASSWORD:
    case LOGIN_SET_LOGIN_MODE:
    case LOGIN_ERROR:
    case LOGIN_SET_REDIRECT_URL:
    case LOGIN_SET_MAGIC_LINK_MODEL:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
